/**
 *
 * Global state to add an entity to SavaneJS and display the corresponding Node in Cocos (on frontView)
 *
 * @param id
 * @constructor
 */

import { ActionState, ActionStateEnum, FrontViewState } from "..";
import { JoineryNode } from "../../plan/EntityNodes/JoineryNode";
import { EntityManager } from "../../plan/EntityManager";
import { FrontViewManager } from "../../plan/FrontViewManager";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { PlanManager } from "../../../../cocosPlan";
import { Commands, Entity, Events, eventsManager, Joinery, joineryManager, math, Velux, Wall } from "@rhinov/savane-js";



export class FrontViewAddJoinery extends ActionState {

    entity: Joinery;
    _node: JoineryNode;
    _lastPosition: math.vec3 | null;
    state: number = ActionStateEnum.FrontViewAddJoinery;
    _cursorPosition!: math.vec3

    constructor(entity: Joinery, create?: boolean) {
        super();
        this.entity = entity;
        PlanManager.getInstance().updateItemsSelected([this.entity], false, false);
        
        // Start temporary state of the joinery so changes are applied to this temporary entity and not to the real entity (easier to undo before the state ends)
        this.entity.startTemporary();
        // Add a new entity to the entity manager (this will create the joinery node)
        EntityManager.getInstance().addEntity(this.entity);
        // Get and store the graphic node of the joinery
        this._node = EntityManager.getInstance().getNode(this.entity) as JoineryNode;
        this._node.setSelected(true);
        this._lastPosition = null
        if (create) {
            this._lastPosition = math.vec3.create();
            if (!PlanManager.getInstance().frontViewLayer.isDirectSide) {
                this._lastPosition[0] = (PlanManager.getInstance().frontViewLayer.currentWall as Wall).length;
            }
        }
    }

    mouseClickUp(cursorPosition: math.vec3, elapsedTime: number, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        var state = new FrontViewState(true);
        // Informt there there is a plan state change
        eventsManager.instance.dispatch(Events.PLAN_STATE_CHANGED, state.getAction());

        if (this.entity.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!)) {
            this.entity.saveAndEndTemporary();
            PlanManager.getInstance().executeCommand(new Commands.AddJoineryCommand(this.entity));

            state._entity = this.entity;

            PlanManager.getInstance().updateItemsSelected([this.entity], false, true);
        }
        else {
            GameObjectManager.deleteJoinery(this.entity.id);
            PlanManager.getInstance().updateItemsSelected(null);
            //Joinery is invalid remove node
            EntityManager.getInstance().removeEntity(this.entity);
            this.entity.deleteFromParent();
        }

        return state;
    }

    moveMouseCursor(cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3): ActionState | null {
        // Record current position
        this._cursorPosition = math.vec3.clone(cursorPosition);

        if (this._lastPosition !== null) {

            // Compute delta X
            var deltaX = (cursorPosition[0] - this._lastPosition[0]);

            // Check wall side (direct or indirect)
            if (!PlanManager.getInstance().frontViewLayer.isDirectSide) {
                // If not direct invert delta X
                deltaX = -deltaX;
            }

            // Yes compute delta Y
            var deltaY = cursorPosition[2] - this._lastPosition[2];

            // Is the joinery a velux ?
            if (this.entity instanceof Velux) {
                // Move joinery from wall by deltaY (will move it away or closer from the wall)
                this.entity.transform.localMatrix[14] = (this.entity as any)._transform.localMatrix[14] + deltaY;
                // Recompute floor height depending on distance from wall
                this.entity.updateFloorHeight();
            }
            else {
                // Compute froor height from delta Y
                this.entity.floorHeight = (this.entity as any)._floorHeight + deltaY;
            }

            // Compute joinery position from begin point (localMatrix[12])
            this.entity.transform.localMatrix[12] = (this.entity as any)._transform.localMatrix[12] + deltaX;

            if (PlanManager.getInstance().snapEnabled) {
                joineryManager.snap(this.entity);
            }

            // Recompute joinery validity
            if (this.entity.temporary) {
                this.entity.temporary.recomputeValidity = true;
            }
        }
        else {
            // Record current position for next loop
            this._lastPosition = this._cursorPosition;
        }

        FrontViewManager.updateDecoration(this.entity, true);
        FrontViewManager.selectDecoration(this.entity);
        FrontViewManager.setValidity(this.entity, this.entity.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!));
        return null;
    }

    mouseClickCancelled(cursorPosition: math.vec3): ActionState | null {
        GameObjectManager.deleteJoinery(this.entity.id);

        PlanManager.getInstance().updateItemsSelected(null);
        EntityManager.getInstance().removeEntity(this.entity);

        this.entity.deleteFromParent();

        return new FrontViewState(true);
    }

    dispose() {

    }
}


